import useConfig from '@/composables/useConfig';
import { SYSTEM_VARIABLES_MAP } from '@/js/constants';

export default class Base {
  constructor(params, actionName) {
    this.name = actionName;
    this.params = params;
    this.resolve = null;

    const { getVariable } = useConfig();
    this.analyticData = {
      // element specific properties
      elementId: `${params.sequenceId}-${params.sequenceIndex}`,
      elementType: `action.${actionName.toUpperCase()}`,
      elementTitle: params.title,
      originalActionType: params.originalActionType,
      sessionId: getVariable(SYSTEM_VARIABLES_MAP.SESSION_ID.id).value,
      sessionStartTime: getVariable(SYSTEM_VARIABLES_MAP.SESSION_START_TIME.id).value,
      ts: new Date(),
    };
  }
}
